import { render, staticRenderFns } from "./FusaiSaichang.vue?vue&type=template&id=280f39d6&scoped=true&"
import script from "./FusaiSaichang.vue?vue&type=script&lang=js&"
export * from "./FusaiSaichang.vue?vue&type=script&lang=js&"
import style0 from "./FusaiSaichang.vue?vue&type=style&index=0&id=280f39d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f39d6",
  null
  
)

export default component.exports